import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/Button.jsx";
import { useNavigate } from "react-router-dom";
import { useErrorTranslation } from "../../../../api/utilities/translateErrorMessage.js";
import HostNameApiIdApiKeyList from "../IntegrationFormInput/HostNameApiIdApiKeyList.jsx";
import { ProjectIntegrationsApi } from "../../../../api/authority/generated/index";
import toast from "react-hot-toast";
import useAuthorityConfiguration from "../../../../api/utilities/useAuthorityConfiguration.js";
import { GlobalContext } from "../../../../utils/context/GlobalContextProvider.jsx";
import {IntegrationActions, IntegrationSection} from "../IntegrationDetailUi.jsx";

export default function ZboziIntegrationForm({ project, projectIntegration }) {
    const { t } = useTranslation();
    const { et } = useErrorTranslation();
    const { resetCurrentUserProjects } = useContext(GlobalContext);
    const navigate = useNavigate();
    const authorityConfiguration = useAuthorityConfiguration();

    const [zboziIntegrationSettings, setZboziIntegrationSettings] = useState({
        hostNameApiIdApiKeyList: [],
    });

    const createZboziIntegration = () => {
        new ProjectIntegrationsApi(authorityConfiguration)
            .zboziIntegration({
                projectId: project.id,
                integrationId: projectIntegration?.id ?? null,
                zboziIntegrationInput: zboziIntegrationSettings,
            })
            .then(zboziIntegrationData => {
                navigate(
                    '/project/' + project.id + '/settings/integrations?integrationId=' + zboziIntegrationData.id
                );
                resetCurrentUserProjects();
                toast.success(projectIntegration === null ? t('created') : t('saved'));
            })
            .catch(e => et(e).then((message) => { if (message) toast.error(message); }));
    };

    return (
        <IntegrationSection
            title={'Domény a přístupy Zboží.cz'}
            description={'Pro každou doménu nastavte její Shop ID a token. Jednotlivé domény lze spravovat nezávisle.'}
        >
            <HostNameApiIdApiKeyList
                project={project}
                projectIntegration={projectIntegration}
                value={zboziIntegrationSettings.hostNameApiIdApiKeyList}
                apiIdPlaceholder={'Shop ID'}
                apiKeyPlaceholder={'Token'}
                onChange={(hostNameApiIdApiKeyList) => {
                    setZboziIntegrationSettings((settings) => ({
                        ...settings,
                        hostNameApiIdApiKeyList,
                    }));
                }}
            />
            <div className={'mt-5'}>
            <IntegrationActions>
                <Button
                    className={'button-primary'}
                    onClick={() => createZboziIntegration()}
                    title={projectIntegration ? 'Uložit změny' : 'Vytvořit integraci'}
                >
                    {projectIntegration ? 'Uložit změny' : 'Vytvořit integraci'}
                </Button>
            </IntegrationActions>
            </div>
        </IntegrationSection>
    );
}
